(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* -------------------------------------------------------
       1. SCROLL REVEAL
       ------------------------------------------------------- */
    var revealElements = document.querySelectorAll('.chi-rv');

    if (revealElements.length) {
      var revealObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('vis');
            revealObserver.unobserve(entries[i].target);
          }
        }
      }, {
        threshold: 0.08,
        rootMargin: '0px 0px -20px 0px'
      });

      for (var i = 0; i < revealElements.length; i++) {
        revealObserver.observe(revealElements[i]);
      }
    }

    /* -------------------------------------------------------
       2. CAROUSEL — Light Finder
       ------------------------------------------------------- */
    var track = document.querySelector('.chi-carousel-track');
    var arrowL = document.querySelector('.chi-arr-l');
    var arrowR = document.querySelector('.chi-arr-r');
    var dotsContainer = document.querySelector('.chi-carousel-dots');

    if (track) {
      var activeFilter = 'all';

      /* --- Filter tabs --- */
      var filterTabs = document.querySelectorAll('.chi-finder-tab');

      function applyFilter(filter) {
        activeFilter = filter;
        var cards = track.querySelectorAll('.chi-series-card');

        for (var c = 0; c < cards.length; c++) {
          var tags = (cards[c].getAttribute('data-tags') || '').split(/\s+/);
          if (filter === 'all' || tags.indexOf(filter) !== -1) {
            cards[c].style.display = '';
          } else {
            cards[c].style.display = 'none';
          }
        }

        track.scrollLeft = 0;
        buildDots();
        updateArrows();
      }

      for (var t = 0; t < filterTabs.length; t++) {
        filterTabs[t].addEventListener('click', function () {
          for (var j = 0; j < filterTabs.length; j++) {
            filterTabs[j].classList.remove('active');
          }
          this.classList.add('active');
          applyFilter(this.getAttribute('data-filter') || 'all');
        });
      }

      /* --- Visible content width helper --- */
      function getVisibleWidth() {
        var cards = track.querySelectorAll('.chi-series-card');
        var total = 0;
        for (var c = 0; c < cards.length; c++) {
          if (cards[c].style.display !== 'none') {
            total += cards[c].offsetWidth + 16; // card width + gap
          }
        }
        return total;
      }

      /* --- Arrows --- */
      function updateArrows() {
        if (!arrowL || !arrowR) return;

        var scrollLeft = Math.round(track.scrollLeft);
        var maxScroll = track.scrollWidth - track.clientWidth;

        if (scrollLeft <= 0) {
          arrowL.classList.add('chi-hidden');
        } else {
          arrowL.classList.remove('chi-hidden');
        }

        if (scrollLeft >= maxScroll - 1) {
          arrowR.classList.add('chi-hidden');
        } else {
          arrowR.classList.remove('chi-hidden');
        }
      }

      if (arrowL) {
        arrowL.addEventListener('click', function () {
          track.scrollBy({ left: -(track.clientWidth * 0.8), behavior: 'smooth' });
        });
      }

      if (arrowR) {
        arrowR.addEventListener('click', function () {
          track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
        });
      }

      /* --- Dots --- */
      function buildDots() {
        if (!dotsContainer) return;

        dotsContainer.innerHTML = '';

        var totalWidth = getVisibleWidth();
        var viewportWidth = track.clientWidth;

        if (totalWidth <= viewportWidth) return;

        var pageCount = Math.ceil(totalWidth / viewportWidth);

        for (var d = 0; d < pageCount; d++) {
          var dot = document.createElement('button');
          dot.className = 'chi-dot';
          dot.setAttribute('aria-label', 'Go to slide group ' + (d + 1));
          dot.setAttribute('data-index', d);

          dot.addEventListener('click', function () {
            var idx = parseInt(this.getAttribute('data-index'), 10);
            track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
          });

          dotsContainer.appendChild(dot);
        }

        updateActiveDot();
      }

      function updateActiveDot() {
        if (!dotsContainer) return;

        var dots = dotsContainer.querySelectorAll('.chi-dot');
        if (!dots.length) return;

        var viewportWidth = track.clientWidth;
        var activeIndex = viewportWidth > 0 ? Math.round(track.scrollLeft / viewportWidth) : 0;

        for (var d = 0; d < dots.length; d++) {
          if (d === activeIndex) {
            dots[d].classList.add('chi-dot-active');
          } else {
            dots[d].classList.remove('chi-dot-active');
          }
        }
      }

      /* --- Scroll listener (debounced) --- */
      var scrollTimer = null;

      track.addEventListener('scroll', function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          updateArrows();
          updateActiveDot();
        }, 60);
      }, { passive: true });

      /* --- Resize listener (debounced) --- */
      var resizeTimer = null;

      window.addEventListener('resize', function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          buildDots();
          updateArrows();
        }, 150);
      });

      /* --- Initialise carousel state --- */
      buildDots();
      updateArrows();
    }

    /* -------------------------------------------------------
       3. SMOOTH SCROLL — Anchor links
       ------------------------------------------------------- */
    var scrollLinks = document.querySelectorAll('.chi-scroll-to');

    for (var s = 0; s < scrollLinks.length; s++) {
      scrollLinks[s].addEventListener('click', function (e) {
        var href = this.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        var target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      });
    }

  });
})();
